import Icon from '../ui/Icon';
import type { Folder } from '../../types/api';

interface FolderDragOverlayProps {
  folder: Folder;
}

function FolderDragOverlay({ folder }: FolderDragOverlayProps) {
  return (
    <div className="bg-surface-primary flex max-w-[180px] cursor-grabbing items-center gap-3 rounded-md px-3 py-1 opacity-90 shadow-lg ring-1 ring-blue-400 dark:ring-blue-500">
      <Icon name={folder.public ? 'folder-public' : 'folder'} />
      <span className="truncate text-xs font-medium">{folder.displayTitle}</span>
    </div>
  );
}

export default FolderDragOverlay;
